import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { IMAGES } from "@/lib/data";
import Home from "@/pages/Home";
import ComingSoon from "@/pages/ComingSoon";

// Public visitors see the "Coming Soon" splash while it's switched on in Admin.
// A logged-in owner/editor still sees the full site so they can check their edits.
export default function SiteEntry() {
  const { user, ready } = useAuth();
  const [comingSoon, setComingSoon] = useState(null); // null = still loading

  useEffect(() => {
    api.get("/config")
      .then(({ data }) => setComingSoon(!!data.coming_soon))
      .catch(() => setComingSoon(false));
  }, []);

  if (comingSoon === null || !ready) {
    return (
      <div className="min-h-screen bg-[#f5f3de] flex items-center justify-center" data-testid="site-entry-loading">
        <img src={IMAGES.logo} alt="Harbour Haze" className="h-20 w-20 object-contain animate-pulse" />
      </div>
    );
  }

  if (comingSoon && !user) return <ComingSoon />;
  return <Home />;
}
